import React, { useEffect, useState } from 'react';
import { isMobile, MobileView } from 'react-device-detect';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Contact from '../containers/Contact';
import EmptyContacts from '../containers/EmptyContacts';
import Instructions from '../containers/Instructions';
import { firestore } from '../../../configs/environments/firebase/firebaseApp';

const messageImg = '/img/empty-state/search.svg';


export default function Contacts({ messagesLaw ,userUid}) {
  const savedContacts = messagesLaw.filter(item => item.save === true);
  const mobileVersion = useMediaQuery('(max-width: 1279px)');

  
  return (
    <>
      {savedContacts && savedContacts.length === 0 ? (
        <EmptyContacts
          title={
            <span>
              Aún no tienes contactos <br />
              guardados
            </span>
          }
          subtitle={
            <span>
              Puedes iniciar dando clic en el ícono
              <br />
              “guardar contacto” para agregarlo a esta lista
            </span>
          }
          img={messageImg}
        />
      ) : (
        <>
          <div style={isMobile ? { padding: '0 8px' } : null}>
            <div className="tabpanel-subhead">
              <p style={{ color: '#013957', marginBottom: 16, fontWeight: 'bold' }}>
                Todos mis contactos
              </p>
            </div>
            {mobileVersion && (
              <div
                className="instructions-wrapper"
                style={{
                  borderBottom: '0.5px solid #e7e7e7',
                  marginBottom: 23,
                }}
              >
                <Instructions />
              </div>
            )}
          </div>

          {savedContacts.map((message, index) => {
              return (
                <Contact
                  //expanded={expanded === message.id}
                  //onChange={handleChange(message)}
                  key={index}
                  user={message}
                  messagesLaw={messagesLaw}
                  userUid={userUid}
                />
              );
          })}
        </>
      )}
    </>
  );
}
